import React from "react";
import "./ReelsCarousel.css";

const ReelCard = ({ reel, onClick }) => {
  return (
    <div className="reel-card" onClick={onClick}>
      <video
        src={reel.media_url}
        poster={reel.thumbnail_url}
        muted={true}
        autoPlay={true}
        loop={true}
        playsInline={true}
      />

      {/* Icon indicating it's a video/reel */}
      <div className="reel-play-icon">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
          <path d="M8 5v14l11-7z" />
        </svg>
      </div>

      <div className="reel-card-overlay">
        <p className="reel-card-caption">{reel.caption || "Instagram Reel"}</p>
      </div>
    </div>
  );
};

export default ReelCard;
